module.exports = __webpack_public_path__ + "media/promo/lum2021/images/herom-1742826dab6f0014b08555adce581cb5.jpg";